import React, { useState, useEffect } from 'react';
import api from '../../api';

const ModelSelect = ({ setIsLoading, setError }) => {
    const [models, setModels] = useState([]);
    
    useEffect(() => {
        const fetchModels = async () => {
            try {
                if (setIsLoading) setIsLoading(true);
                const response = await api.get('/models');
                
                // Transformer les données en options pour le select
                const modelOptions = Object.entries(response.data).map(([id, model]) => ({
                    value: id,
                    label: model.name + (model.available ? '' : ' (API key required)'),
                    disabled: !model.available,
                    provider: model.provider
                }));
                
                // Trier les modèles par fournisseur puis par nom
                modelOptions.sort((a, b) => {
                    if (a.provider !== b.provider) {
                        return a.provider.localeCompare(b.provider);
                    }
                    return a.label.localeCompare(b.label);
                });
                
                setModels(modelOptions);
            } catch (error) {
                console.error('Error fetching models:', error);
                if (setError) setError('Failed to load available models');
            } finally {
                if (setIsLoading) setIsLoading(false);
            }
        };
        
        fetchModels();
    }, [setIsLoading, setError]);
    
    return {
        id: 'model',
        type: 'select',
        label: 'AI Model',
        defaultValue: 'openai',
        options: models.length > 0 ? models : [
            // Options par défaut en cas d'échec de chargement
            { value: 'openai', label: 'GPT-4o' }
        ]
    };
};

export default ModelSelect; 